import React, { useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useSettings } from '@/hooks/useSettings';
import { LoadingSpinner } from './LoadingSpinner';

export const SettingsInitializer: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, isLoading: authLoading } = useAuth();
  const { isLoaded: settingsLoaded } = useSettings();

  // Settings are automatically loaded by the useSettings hook
  // This component just ensures they're loaded before rendering children
  
  // Don't block rendering for public pages or when auth is still loading
  if (!isAuthenticated || authLoading) {
    return <>{children}</>;
  }
  
  // Only show loading spinner for authenticated users while settings load
  if (isAuthenticated && !settingsLoaded) {
    return <LoadingSpinner message="Loading settings..." />;
  }

  return <>{children}</>;
}; 